var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticStyle:{"z-index":"9999"},attrs:{"visible":_vm.visible,"modal-append-to-body":false,"before-close":_vm.onClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('img',{attrs:{"width":"100%","src":_vm.imageSrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }